const getCookie = name => {
  // "Read" part of a "little cookie framework"
  // https://developer.mozilla.org/en-US/docs/DOM/document.cookie
  //
  // This framework is released under the GNU Public License, version 3 or later.
  // http://www.gnu.org/licenses/gpl-3.0-standalone.html
  return (
    decodeURIComponent(
      document.cookie.replace(
        new RegExp(
          "(?:(?:^|.*;)\\s*" +
            encodeURIComponent(name).replace(/[-.+*]/g, "\\$&") +
            "\\s*\\=\\s*([^;]*).*$)|^.*$"
        ),
        "$1"
      )
    ) || null
  );
};

export default getCookie;
